
import { ResultData } from "@nt-portal/common-sdk";

import { DbInuseResult, TCMSpecificGoal, TCMSpecificGoalKeys, TCMSpecificGoalService } from "@nt-portal/tcm-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";
import { ValidateResult } from "@nt-portal/common-sdk";


export interface TCMSpecificGoalOptions extends ControllerOptions<TCMSpecificGoal> {
    goalType?: string;
}

export const SpecificGoalTypes =  ["system", "manual"];

export const createTCMSpecificGoal = (obj: Partial<TCMSpecificGoal>) => {
    let item: TCMSpecificGoal = {
        validationKey: obj.validationKey || "",
        name: obj.name || "",
        createdBy: "",
        goalType: "system",
        goalArea: "schedule"
    }
    return item;
}

export class ClientTCMSpecificGoalService extends BaseClientService implements DataController<TCMSpecificGoal> {

    private _service: TCMSpecificGoalService;


    constructor() {
        super();
        this._service = new TCMSpecificGoalService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }



    public async get(options: TCMSpecificGoalOptions): Promise<ResultData<TCMSpecificGoal>> {
        return await this._service.get(this.buildFetchParams(options), this.token, options.filter);
    }

    public async getLookup(options: TCMSpecificGoalOptions): Promise<ResultData<TCMSpecificGoal>> {

        let fetchParams = this.buildLookupFetchParams(options);
        let data = await this._service.get(fetchParams, this.token, options.filter);
        return data;

    }

    public async getById(options: TCMSpecificGoalOptions): Promise<TCMSpecificGoal | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: TCMSpecificGoalOptions): Promise<any> {
        if (options.id)
            await this._service.delete(options.id, this.token);
    }

    public async inUse(options: TCMSpecificGoalOptions): Promise<DbInuseResult[]> {
        if (options.id) {
            return await this._service.inUse(options.id, this.token);
        }
        return [];
    }

    public async update(options: TCMSpecificGoalOptions): Promise<TCMSpecificGoal | TCMSpecificGoal[] | null> {
        if (options.item && options.item.id)
            return await this._service.update(options.item.id, options.item, this.token)
        return null;
    }
    public async add(options: TCMSpecificGoalOptions): Promise<TCMSpecificGoal | TCMSpecificGoal[] | null> {
        if (options.item)
            return await this._service.add(options.item, this.token)
        return null;
    }

    public async validateName(name: string, id?: string): Promise<ValidateResult> {

        return await this._service.validateName(name, this.token, id)

    }

    public async import(options: TCMSpecificGoalOptions): Promise<any> {
        if (options.file)
            return await this._service.importExcel(options.file, this.token);
    }

    public async export(options: TCMSpecificGoalOptions): Promise<any> {
        let fetchParams = this.buildLookupFetchParams(options);
        return await this._service.export(this.token, fetchParams, options.filter);
    }

    public async goalKeys(): Promise<TCMSpecificGoalKeys[]> {
        return this._service.goalKeys(this.token);
    }

}